import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-debt-income-calculator',
  templateUrl: './debt-income-calculator.component.html',
  styleUrls: ['./debt-income-calculator.component.scss']
})
export class DebtIncomeCalculatorComponent implements OnInit {
  debtToIncomeCalcIntro: string = 'The Debt-to-Income Calculator can help you determine if you are likely eligible for a mortgage. Simply enter your annual income along with your monthly payments to calculate your debt-to-income ratio (a score of 36% or less is considered ideal).';

  annualIncome: number = 70000;
  mortgagePayment: number = 1100;
  creditCardPayments: number = 200;
  carLoanPayments: number = 500;
  studentLoanPayments: number = 300;
  alimonyPayments: number = 0;
  secondaryHomeExpenses: number = 0;
  otherLoanPayments: number = 0;

  monthlyDebts: number = 0;
  remainingMonthlyIncome: number = 0;
  dtiRatio: number = 0;
  results: any[] = [];
  total: string = '';

  ngOnInit(): void {
    this.calculateDTI();
  }

  calculateDTI(): void {
    const monthlyIncome = this.annualIncome / 12;
    const monthlyDebts = this.mortgagePayment + this.creditCardPayments + this.carLoanPayments + this.studentLoanPayments + this.alimonyPayments + this.secondaryHomeExpenses + this.otherLoanPayments;

    this.monthlyDebts = monthlyDebts;
    this.remainingMonthlyIncome = monthlyIncome - monthlyDebts;
    this.dtiRatio = parseFloat(((monthlyDebts / monthlyIncome) * 100).toFixed(2));

    this.results = [
      { label: 'Monthly Debts', value: monthlyDebts },
      { label: 'Mortgage Payment', value: this.mortgagePayment },
      { label: 'Remaining Mo. Income', value: this.remainingMonthlyIncome }
    ];
    this.total = Math.round(monthlyIncome).toFixed(2);
  }

  onKeyDown(event: KeyboardEvent, functionToRun: () => void): void {
    if (event.key === 'Enter') {
      event.preventDefault();
      functionToRun();
    }
  }
}
